import React from "react";
import { useUser } from "src/shared/context/UserContext";
import ThermalPrinter1 from "./ThermalPrinter1";
import ThermalPrinter2 from "./ThermalPrinter2";
import ThermalPrint3 from "./ThermalPrint3";
import { ProductNote, ReturnItem } from "src/shared/services/interface";
import PrintAppFind from "./PrintAppFind";
import PrintSection from "src/shared/configurations/commonPrint/html/PrintSection";
import { AppPrint, SystemPrint } from "./printBaseCode";

export const formatTerms = (text: string) => {
  if (!text) return "";
  return text.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>");
};

export interface PrintData {
  CustomerName: string;
  CustomerPhon: string;
  OrderId: string;
  OrderStatus: string;
  discount: number;
  deliveryFee?: number;
  Date: string;
  returnAmount?: number;
  changeAmount?: number;
  balance?: number;
  Time: string;
  parcelFee?: number;
  tip?: string | number;
  Products?: Array<{
    productName: string;
    arabicword?: string;
    amount: number;
    quantity: number;
    totalPrice: number;
    uom?: string;
    addOns?: ProductNote[];
    barcodeId?: any;
  }>;
  returnProducts?: ReturnItem[];
  deliveryType?: string;
  sellerName?: string;
  Paid: number;
  unpaid: number;
  Tip?: string | number;
  OSB?: string | number;
  paymentMethod?: string;
  total: string | number;
  subtotal: number;
  imglogo?: any;
  businessLocation?: string;
  clientId?: string;
  billNo?: number;
  prvPaid?: number;
  prvBalance?: number;
  prvAvabile?: boolean;
  payMentHistory?: Array<{
    Paymentmethod: string;
    ReceivedAmount: number;
    date: string;
    payment_on: string;
    balance: number;
    paidAmount: number;
    balanceReturned?: number;
    adjustAmount?: number;
    refundAmount?: number;
  }>;
  payMentHistoryAvabile?: boolean;
  businessType?: string;
  resvedAmount?: number;
  balanceReturned?: number;
  balanceEnabiled?: boolean;
  createdBy?: string;
}

export interface ledgerPaid {
  Balance: number;
  Paid: number;
  PreviousBalance?: number;
  previousLabel?: string;
  paidLabel?: string;
  balanceLabel?: string;
  isAdvance?: boolean;
  clientId: string;
  CustomerPhon: number;
  CustomerName: string;
  Time: string;
  Date: string;
  paymentMethod: string;
  billNo: number;
  discount?: number;
  createdBy?: string;
}

export interface ThermalPrinterTestProps {
  PrintData?: PrintData;
  BtnName?: string;
  openPrint?: string;
  paymentMethod?: string;
  username?: string;
  isClosed?: (data: boolean) => void;
  ledgerPaid?: ledgerPaid;
  barcodeTrue?: boolean;
  icon?: any;
  className?: string;
  handleAppPrint?: (data: any) => void;
  disabled?: boolean;
  onBeforePrint?: () => void;
  onAfterPrint?: () => void;
  printerCheck?: string;
  refundPrint?: RefundData;
}
interface RefundData {
  orderId: string;
  refundAmount: number;
  // refundType: RefundType;
}

export const LABELS = {
  orderId: "Order ID (رقم الطلب)",
  billNo: "Bill No (رقم الفاتورة)",
  status: "Status (الحالة)",
  paymentType: "Pay. Type (طريقة الدفع)",
  date: "Date (التاريخ)",
  time: "Time (الوقت)",
  sellerName: "Seller Name (اسم البائع)",
  deliveryType: "Delivery Type (نوع التوصيل)",

  customerName: "Cus. Name (اسم العميل)",
  customerPhone: "Cus. Phone (رقم الهاتف)",
  clientId: "Client ID (رقم العميل)",

  productName: "Product Name <br/> اسم المنتج",
  quantity: "Qty <br/> الكمية",
  price: "Price <br/> السعر <br/> (ر.ق)",
  total: "Total  الإجمالي <br/> (ر.ق)",

  subtotal: "Subtotal (المجموع الفرعي)",
  discount: "Discount (الخصم)",
  deliveryFee: "Delivery Fee (رسوم التوصيل)",
  paid: "Paid (المدفوع)",
  due: "Due (المتبقي)",
  outstanding: "Outstanding (الرصيد المستحق)",
  total2: "Total  (الإجمالي)",

  paymentHistory: "Payment History (سجل المدفوعات)",
  paymentMethod: "Method (الطريقة)",
  received: "Received (المستلم)",
  balance: "Balance (الرصيد)",
};

function PrintConfigration(props: ThermalPrinterTestProps) {
  const { userConfigration, user } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";

  const appPrinterEnabled = toBoolean(userConfigration?.appPrinterEnabled);

  // ✅ Only call PrintAppFind if enabled
  const { handlePrint } = PrintAppFind();

  const printPage = userConfigration?.printType;

  const checkPrinter = user?.businessType === "Grocery" ? (printPage === "print:1" ? "print:2" : printPage) : printPage

  const printerCheck = appPrinterEnabled ? AppPrint : SystemPrint;

  // const isLedgerPrint = Boolean(props.ledgerPaid);

  return (
    <>
      {checkPrinter === "print:1" && <ThermalPrinter1 {...props} />}
      {checkPrinter === "print:2" && <ThermalPrinter2 {...props} printerCheck={printerCheck} handleAppPrint={(data) => handlePrint(data)} />}
      {checkPrinter === "print:3" && <ThermalPrint3 {...props} handleAppPrint={(data) => handlePrint(data)} printerCheck={printerCheck} />}
    </>
    // <>
    //   {userConfigration?.customEnabledPrint ? (
    //     <PrintSection
    //       BtnName={props.BtnName}
    //       printData={props.PrintData}
    //       ledgerPaid={props.ledgerPaid}
    //       ledgerPaidAvabile={isLedgerPrint}
    //       openPrint={props.openPrint}
    //     />
    //   ) : (
    //     <>
    //       {printPage === "print:1" && <ThermalPrinter1 {...props} />}
    //       {printPage === "print:2" && <ThermalPrinter2 {...props} printerCheck={printerCheck} handleAppPrint={(data) => handlePrint(data)} />}
    //       {printPage === "print:3" && <ThermalPrint3 {...props} handleAppPrint={(data) => handlePrint(data)} printerCheck={printerCheck} />}
    //     </>
    //   )}
    // </>
  );
}

export default PrintConfigration;
